// Багшийн layout (Tomujin Design System): цагаан толгой — лого, Нүүр · Миний ангиуд · Хуваарь · (Миний хаус), мэдэгдэл, профайл.
// Бага ангийн багш: Миний анги · 7 хоногийн тайлан · Хуваарь (заадаг хичээлтэй бол Миний ангиуд ч). Утсанд доод цэс.
import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Dropdown } from "antd";
import { BiBookOpen, BiCalendar, BiFlag, BiHomeAlt, BiUserCircle, BiStar, BiClipboard, BiDish, BiFolder } from "react-icons/bi";
import { AuthContext } from "contexts";
import { usePortal, clearPortalMode, switchItems } from "contexts/portal";
import { instance } from "utils/axios";
import NotificationBell from "layout/components/header/NotificationBell";
import logo from "assets/images/logo.png";
import { Avatar, prefetch } from "./common";
import "./tj.css";

const NAV = [
  { to: "/t", label: "Нүүр", icon: BiHomeAlt, match: (p) => p === "/t" },
  { to: "/t/classes", label: "Миний ангиуд", icon: BiBookOpen, match: (p) => p.startsWith("/t/class") || p.startsWith("/lms/task") || p.startsWith("/exams") || p.startsWith("/lms/projects") },
  { to: "/t/schedule", label: "Хуваарь", icon: BiCalendar, match: (p) => p.startsWith("/t/schedule") },
  { to: "/t/pbl", label: "Миний төслүүд", short: "Төсөл", icon: BiFolder, match: (p) => p.startsWith("/t/pbl") },
  { to: "/t/house", label: "Миний хаус", icon: BiFlag, match: (p) => p.startsWith("/t/house"), house: true },
  { to: "/t/assistant", label: "✦ Хувийн туслах", short: "Туслах", icon: BiStar, match: (p) => p.startsWith("/t/assistant") },
];

// Бага ангийн багшийн цэс (/t/e)
const ELEM_NAV = [
  { to: "/t/e", label: "Миний анги", short: "Анги", icon: BiHomeAlt, match: (p) => p === "/t/e" },
  { to: "/t/e/week", label: "7 хоногийн тайлан", short: "Тайлан", icon: BiClipboard, match: (p) => p.startsWith("/t/e/week") || p.startsWith("/t/e/report") || p.startsWith("/t/e/s/") },
  { to: "/t/e/projects", label: "Төсөл, даалгавар", short: "Төсөл", icon: BiFolder, match: (p) => p.startsWith("/t/e/projects") },
  { to: "/t/e/schedule", label: "Хуваарь", icon: BiCalendar, match: (p) => p.startsWith("/t/e/schedule") },
  { to: "/t/e/meals", label: "Хоолны цэс", short: "Хоол", icon: BiDish, match: (p) => p.startsWith("/t/e/meals") },
];

// Бага ангийн багш: албан тушаал (ж: "Бага ангийн туслах багш"); бусад: "Физик багш", олон хичээл бол жагсаана
const titleOf = (me) => (me?.elementary?.length ? (me.position?.trim().length > 1 ? me.position : "Бага ангийн багш")
  : !me?.subjects?.length ? "Багш" : `${me.subjects.join(", ")} багш`);

export default function TeacherLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { action } = useContext(AuthContext);
  const portal = usePortal();
  const [me, setMe] = useState(null);
  useEffect(() => {
    instance({ method: "get", url: "/teacher/profile", noMessage: true }).then((r) => setMe(r.data)).catch(() => {});
    // Гол цэсүүдийн өгөгдлийг урьдчилан татах — шилжихэд шууд нээгдэнэ
    prefetch("/teacher/v2/home");
    prefetch("/teacher/reflections");
    setTimeout(() => prefetch("/teacher/schedule", {}), 1500);
  }, []);
  const path = location.pathname;
  const elem = !!me?.elementary?.length;
  // Бага ангийн багш: өөр хичээл заадаггүй бол ердийн Нүүр, Миний ангиуд, Хувийн туслахыг нууна
  const nav = elem
    ? [...ELEM_NAV, ...NAV.filter((n) => (me.subjects?.length ? n.to === "/t/classes" : false) || (n.house && me.houses?.length))]
    : NAV.filter((n) => !n.house || me?.houses?.length);
  useEffect(() => { if (elem && !me.subjects?.length && path === "/t") navigate("/t/e", { replace: true }); }, [elem, path]); // eslint-disable-line react-hooks/exhaustive-deps

  const logout = () => { clearPortalMode(); action.logout(); navigate("/login"); };
  const menu = {
    items: [
      { key: "profile", label: "Хувийн мэдээлэл", onClick: () => navigate("/me") },
      ...switchItems(portal, navigate),
      { type: "divider" },
      { key: "logout", label: "Гарах", onClick: logout },
    ],
  };

  return (
    <div className="tj pb-20 md:pb-0">
      <header className="tj-header">
        <div className="tj-container py-2.5 flex flex-wrap items-center gap-x-7 gap-y-2">
          <Link to={elem ? "/t/e" : "/t"} aria-label="Нүүр" className="shrink-0"><img src={logo} height={34} style={{ height: 34, width: "auto" }} alt="Tomujin Alternative School" /></Link>
          <nav aria-label="Үндсэн цэс" className="tj-nav hidden md:flex flex-wrap gap-1 flex-1">
            {nav.map((n) => <Link key={n.to} to={n.to} aria-current={n.match(path, location.hash) ? "page" : undefined}>{n.label}</Link>)}
          </nav>
          <div className="ml-auto flex items-center gap-3">
            <NotificationBell />
            <Dropdown menu={menu} trigger={["click"]} placement="bottomRight">
              <button type="button" className="flex items-center gap-2.5 bg-transparent border-0 cursor-pointer p-0" style={{ fontFamily: "inherit" }}>
                <Avatar user={me} size={36} tone="purple" />
                <span className="hidden sm:flex flex-col text-left leading-tight">
                  <span className="text-sm font-semibold text-[#1c1c1c]">{me ? `${me.lastName?.[0] || ""}. ${me.firstName}` : ""}</span>
                  <span className="text-xs text-[#6e5e8a]">{titleOf(me)}</span>
                </span>
              </button>
            </Dropdown>
          </div>
        </div>
      </header>
      <main>{children}</main>
      <nav aria-label="Үндсэн цэс" className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-[#e5d8f5] grid" style={{ gridTemplateColumns: `repeat(${nav.length + 1}, minmax(0, 1fr))`, paddingBottom: "env(safe-area-inset-bottom)" }}>
        {[...nav, { to: "/me", label: "Хувийн мэдээлэл", short: "Миний", icon: BiUserCircle, match: (p) => p === "/me" }].map((n) => {
          const on = n.match(path, location.hash);
          const I = n.icon;
          return (
            <Link key={n.to} to={n.to} aria-current={on ? "page" : undefined} className={`flex flex-col items-center justify-center gap-0.5 min-h-[56px] text-[11px] ${on ? "!text-[#5c1090] font-bold" : "!text-[#6e5e8a] font-semibold"}`}>
              <I size={22} aria-hidden="true" />{n.short || n.label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
